// Refonte du suivi : copie locale des modifications pas encore en base.
//
// Si Anissa quitte la fiche (autre cliente, autre écran, onglet fermé) alors
// qu'un envoi échoue — typiquement hors connexion — ses modifications restent
// dans ce navigateur, rangées par version et révision, jusqu'à leur
// enregistrement. À la réouverture de la version, elles sont reprises avec un
// message clair. Tout accès au stockage est protégé : un navigateur sans
// stockage (navigation privée, quota plein) fonctionne comme avant.

const PREFIXE = 'suivi:attente:';

function stockageParDefaut() {
  try {
    return globalThis.localStorage || null;
  } catch {
    return null;
  }
}

const cle = (consultationId, revision) => `${PREFIXE}${consultationId}:${revision}`;

// Durée de vie d'une copie locale (décision du 16.10, par défaut prudente) :
// au-delà, elle est effacée au démarrage et jamais reprise.
export const DUREE_COPIE_LOCALE_MS = 48 * 60 * 60 * 1000;

function toutesLesCles(stockage) {
  const liste = [];
  try {
    for (let i = 0; i < stockage.length; i += 1) {
      const k = stockage.key(i);
      if (k && k.startsWith(PREFIXE)) liste.push(k);
    }
  } catch {
    return [];
  }
  return liste;
}

/** À la déconnexion : efface toutes les copies locales du suivi. */
export function purgerBrouillonsLocaux(stockage = stockageParDefaut()) {
  if (!stockage) return 0;
  const liste = toutesLesCles(stockage);
  for (const k of liste) {
    try { stockage.removeItem(k); } catch { /* stockage indisponible */ }
  }
  return liste.length;
}

/** Au démarrage : efface les copies plus vieilles que 48 h (ou illisibles). */
export function purgerBrouillonsAnciens(stockage = stockageParDefaut(), maintenant = Date.now()) {
  if (!stockage) return 0;
  let n = 0;
  for (const k of toutesLesCles(stockage)) {
    let le = NaN;
    try { le = Date.parse(JSON.parse(stockage.getItem(k))?.le); } catch { le = NaN; }
    if (!Number.isFinite(le) || maintenant - le > DUREE_COPIE_LOCALE_MS) {
      try { stockage.removeItem(k); n += 1; } catch { /* stockage indisponible */ }
    }
  }
  return n;
}

export function creerBrouillonLocal(stockage = stockageParDefaut()) {
  const cles = (consultationId) => {
    if (!stockage) return [];
    try {
      const debut = `${PREFIXE}${consultationId}:`;
      const liste = [];
      for (let i = 0; i < stockage.length; i += 1) {
        const k = stockage.key(i);
        if (k && k.startsWith(debut)) liste.push(k);
      }
      return liste;
    } catch {
      return [];
    }
  };
  const effacer = (consultationId) => {
    for (const k of cles(consultationId)) {
      try { stockage.removeItem(k); } catch { /* stockage indisponible */ }
    }
  };
  return {
    /** Copies gardées pour cette version : [{ revision, enAttente, refuses, le }]. */
    lire(consultationId) {
      if (!consultationId) return [];
      return cles(consultationId).map((k) => {
        try {
          const valeur = JSON.parse(stockage.getItem(k));
          if (!valeur || typeof valeur !== 'object') return null;
          const le = Date.parse(valeur.le);
          // Trop ancienne (> 48 h) : jamais reprise.
          if (!Number.isFinite(le) || Date.now() - le > DUREE_COPIE_LOCALE_MS) return null;
          return valeur;
        } catch {
          return null;
        }
      }).filter(Boolean);
    },
    /** Remplace la copie de cette version par l'état courant. */
    ecrire(consultationId, revision, { enAttente = {}, refuses = [] } = {}) {
      if (!stockage || !consultationId) return;
      effacer(consultationId);
      try {
        stockage.setItem(cle(consultationId, revision), JSON.stringify({
          revision, enAttente, refuses, le: new Date().toISOString(),
        }));
      } catch {
        // Quota plein ou stockage refusé : l'enregistrement en base continue.
      }
    },
    effacer,
  };
}
